// extracted by mini-css-extract-plugin
module.exports = {"modalStyle":"legacy-modal_component_modalStyle__P9V8C","overlayStyle":"legacy-modal_component_overlayStyle__NlI7K"};